import { VehicleAbsDto } from './vehicle-abs.dto';
import { VehicleBcmDto } from './vehicle-bcm.dto';
import { VehicleEcuDto } from './vehicle-ecu.dto';
import { VehicleEnvironmentDto } from './vehicle-environment.dto';
import { VehicleTpmsDto } from './vehicle-tpms.dto';

export interface VehicleMetricsResponseDto {
  id: string;
  tenantID: string;
  type: string;
  updatedDate: string;
  value: VehicleAbsDto | VehicleBcmDto | VehicleTpmsDto | VehicleEcuDto | VehicleEnvironmentDto;
}
